<template>
  <div class="text-[#fff] text-[14px] mb-10px w-full">
    <div v-for="(item, index) in markerList" :key="item.Id" class="mb-20px w-full">
      <div
        class="border-l-[3px] mb-10px border-solid border-[var(--buttonPrimaryBg)] pl-10px flex justify-between items-center"
      >
        <span>标记备注{{ index + 1 }}</span>
      </div>
      <div class="flex w-full pl-10px mb-15px">
        <div class="w-100px">标记描述:</div>
        <div class="break-words el-textarea__inner !text-[14px] h-78px overflow-hidden">
          <span style="white-space: break-spaces" class="leading-tight">{{ item.BiaojiMS }}</span>
        </div>
        <!-- <el-input
          :disabled="true"
          :autosize="{ maxRows: 3, minRows: 3 }"
          v-model="item.BiaojiMS"
          size="small"
          resize='none'
          placeholder=""
          type="textarea"
        ></el-input> -->
      </div>
      <el-row :gutter="3" class="text-[12px] w-full" justify="space-between">
        <el-col :span="9" class="text-ellipsis overflow-hidden whitespace-nowrap">
          <span>备注人员：</span>
          <el-tooltip class="item" effect="dark" :content="item.UserName" placement="top-start">
            <span>{{ item.UserName }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="13" class="text-ellipsis overflow-hidden whitespace-nowrap">
          <span>标记时间：</span>
          <span>{{ item.UpdateTime  }}</span>
        </el-col>
        <el-col :span="2" class="flex justify-between">
          <i class="el-icon-edit-outline mr-5px cursor-pointer text-[14px] text-[#02dc0b]" @click="editItem(item)"></i>
          <i class="el-icon-delete cursor-pointer text-[14px] text-[#02dc0b]" @click="deleteItem(item)"></i>
        </el-col>
      </el-row>
    </div>
    <remark-dialog
      v-if="openDialog"
      :remarkData="currentRemark"
      :FlagId="markerId"
      @close="closeDialog"
    >
    </remark-dialog>
  </div>
</template>

<script>
import DiyCodeService from '../../../../service/DiyCodeService.js'
import RemarkDialog from './remarkDialog'

export default {
  props: ['markerId'],
  components: { RemarkDialog },
  data() {
    return {
      markerList: [],
      openDialog: false,
      currentRemark: {},
    }
  },
  watch: {
    markerId: {
      handler(val) {
        if (val) {
          this.getList()
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getList() {
      const [err, res] = await DiyCodeService.getPipesData({
        FormEngineKey: 'diy_3DCoordinationManagement_Descripts',
        _Where: [{ Name: 'FlagId', Value: this.markerId, Type: '=' }],
      })
      if (!err && res.Code === 1) {
        res.Data.forEach((element) => {
          element.UpdateTime ? null : (element.UpdateTime = element.CreateTime)
        })
        this.markerList = _.orderBy(res.Data, ['UpdateTime'], ['asc'])
      }
    },
    deleteItem(item) {
      this.$confirm('删除后将无法恢复, 确认删除', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {
        const [err, res] = await DiyCodeService.delFormData({
          FormEngineKey: 'diy_3DCoordinationManagement_Descripts',
          Id: item.Id,
        })
        if (!err && res.Code === 1) {
          this.$message.success('删除成功！')
          this.getList()
        }
      })
    },
    editItem(item) {
      this.currentRemark = item
      this.openDialog = true
    },
    closeDialog() {
      this.openDialog = false
      this.getList()
    },
    openRemark() {
      this.currentRemark = {}
      this.openDialog = true
    },
  },
}
</script>
